import invoiceInstance from './instance'

const fetchInvoices = (page, size, statuses = []) => {
	const statusParams = statuses.map(status => `&status=${status}`).join('')
	return invoiceInstance.get(`/invoices?page=${page}&size=${size}${statusParams}`)
}

export const createPaidOrderInvoice = (orderId, recipient) => invoiceInstance.post('/invoices', { orderId, ...recipient })

export default fetchInvoices
